import Modal from "react-bootstrap/Modal";
import { styleEnd } from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";

import { getDir, getCurrentLangFromRedux } from "../../algorithms/styleChanges";

const NotAllowedModal = (props) => {
  const { onHide } = props;

  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "white",
                height: 30,
                width: 30,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center px-1"
            >
              <img
                src="/assets/images/Group 8274.png"
                width={30}
                height={30}
                alt=""
              />
            </div>

            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "#1a73e8",
                }}
              >
                تعديل المنشور
              </p>
            </div>
          </div>
        </Modal.Title>
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"#1A73E8"}
            onclick={() => {
              onHide();
            }}
          />
        </div>
      </Modal.Header>

      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <div className="text-center m-5">
          You are not allowed to edit this post
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default NotAllowedModal;
